(function () {
  const launcherStyles = `
    :host {
      display: inline-block;
      overflow: visible;
    }

    .rt-launcher-host {
      display: inline-block;
      overflow: visible;
    }

    .rt-launch-btn {
      position: relative;
      z-index: 1;
      display: inline-block;
      width: auto;
      min-height: var(--space-8);
      margin: 0 0 .6875rem;
      padding: 0 var(--space-5);
      color: var(--button-text) !important;
      border: 1px solid var(--button-text) !important;
      border-radius: var(--buttons-corners) !important;
      background: var(--button-bg) !important;
      box-shadow: none;
      font-family: var(--main-family);
      font-size: var(--font-size);
      font-style: var(--main-style);
      font-weight: var(--main-weight);
      letter-spacing: var(--main-spacing);
      line-height: var(--space-8);
      text-decoration: none;
      text-transform: var(--buttons-transform);
      transition: .3s ease-out;
      vertical-align: middle;
    }

    .rt-launch-logo {
      display: none;
    }

    .rt-launch-btn:focus-visible {
      outline: var(--keyboard-focus) var(--keyboard-border-style) var(--keyboard-border-weight);
      outline-offset: var(--keyboard-border-offset-weight);
    }

    :host-context(.buttons--borders) .rt-launch-btn::after {
      position: absolute;
      z-index: -1;
      top: .375rem;
      left: .375rem;
      width: 100%;
      height: 100%;
      content: "";
      border: 1px solid var(--button-text);
      border-radius: 1px;
      background: var(--button-bg);
      transition: all .3s ease-in-out;
    }

    :host-context(.buttons--borders) .rt-launch-btn:hover::after {
      top: -.0625rem;
      left: -.0625rem;
    }

    :host-context(.buttons--layer) .rt-launch-btn {
      border-color: transparent;
    }

    :host-context(.buttons--layer) .rt-launch-btn::after {
      position: absolute;
      z-index: -1;
      top: 0;
      bottom: 0;
      left: 0;
      width: 0;
      content: "";
      visibility: hidden;
      background: var(--button-text);
      transition: width .25s ease;
    }

    :host-context(.buttons--layer) .rt-launch-btn:hover {
      color: var(--button-bg);
      border-color: var(--button-bg);
    }

    :host-context(.buttons--layer) .rt-launch-btn:hover::after {
      width: 100%;
      visibility: visible;
    }
  `;

  function styleLauncher(section) {
    const host = section.querySelector('.rt-launcher-host');
    const root = host && host.shadowRoot;

    if (!root) return false;

    if (!root.querySelector('[data-foodie-booking-launcher-css]')) {
      const style = document.createElement('style');
      style.dataset.foodieBookingLauncherCss = '';
      style.textContent = launcherStyles;
      root.appendChild(style);
    }

    const label = section.dataset.bookingButtonLabel;
    const labelElement = root.querySelector('.rt-launch-btn span');
    if (label && labelElement) labelElement.textContent = label;

    return true;
  }

  function initSection(section) {
    if (styleLauncher(section)) return;

    const observer = new MutationObserver(function () {
      if (styleLauncher(section)) observer.disconnect();
    });

    observer.observe(section, { childList: true, subtree: true });
  }

  function initAll(container) {
    container.querySelectorAll('[data-booking-widget]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
